"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseCellphone = exports.parseEmail = exports.parseUsername = void 0;

var _errors = require("../errors");

var _validators = require("../validators");

const parseEmail = async email => {
  try {
    return {
      emailAddress: await (0, _validators.validateEmail)(email)
    };
  } catch (err) {
    throw new _errors.PayloadError('Email is on an invalid format.');
  }
};

exports.parseEmail = parseEmail;

const parseCellphone = async phone => {
  try {
    return await (0, _validators.validatePhone)(phone);
  } catch (err) {
    throw new _errors.PayloadError('Cellphone is on an invalid format.');
  }
};

exports.parseCellphone = parseCellphone;

const parseUsername = async username => {
  try {
    return await Promise.any([(0, _validators.validateEmail)(username), (0, _validators.validateDocument)(username), (0, _validators.validatePhone)(username)]);
  } catch (err) {
    throw new _errors.PayloadError('Username is on an invalid format');
  }
};

exports.parseUsername = parseUsername;